export const cardData = [
    {
        "id" : "0",
        "svg": "User",
        "cardName" : "User",
        "description" : "Shows details from ck_user table with a specific Login Id",
        "query" : "SELECT * FROM ck_user WHERE loginid = ;",
        "api" : "/users?filter=",
        "filters" : {
            "Log In User Name" : "loginId"
        },
        "filtersCheck" : {
            "check" : true,
            "value" : ":"
        }
    },
    {
        "id" : "1",
        "svg":"Targets",
        "cardName" : "Targets",
        "description" : "Shows details from ck_targets table with a specific Login Id and Date",
        "query" : "SELECT * FROM ck_targets WHERE loginid = '' AND date = '';",
        "api" : "/v1/query/dataValidation_target/?",
        "filters" : {
            "Log In User Name" : "loginId",
            "Date" : "date"
        },
        "filtersCheck" : {
            "check" : true,
            "value" : "="
        }
    },
    {
        "id" : "2",
        "svg":"PJPVisitPlan",
        "cardName" : "PJPVisitPlan",
        "description" : "Shows details from ck_delivery_pjp table with a specific Login Id and Date",
        "query" : "SELECT * FROM ck_delivery_pjp WHERE loginid = '' AND date = '';",
        "api" : "/v1/query/dataValidation_pjp/?",
        "filters" : {
            "Log In User Name" : "loginId",
            "Date" : "date"
        },
        "filtersCheck" : {
            "check" : true,
            "value" : "="
        }
    },
    {
        "id" : "3",
        "svg": "OutletDetails",
        "cardName" : "OutletDetails",
        "description" : "Shows details from ck_outlet_details table with a specific Login Id",
        "query" : "SELECT * FROM ck_outlet_details WHERE loginid = '';",
        "api" : "/outletDetails/outletcode/",
        "filters" : {
            "Outlet Code" : "OutletCode"
        },
        "filtersCheck" : {
            "check" : false,
            "value" : ""
        }
    },
    {
        "id" : "4",
        "svg": "Variable",
        "cardName" : "Device Info",
        "description" : "Shows details from ck_device_info table with a specific Login Id",
        "query" : "SELECT * FROM ck_outlet_details WHERE loginid = '';",
        "api" : "/v1/query/dataValidation_device/?",
        "filters" : {
            "Log In User Name" : "loginId"
        },
        "filtersCheck" : {
            "check" : true,
            "value" : "="
        }
    },
    {
        "id" : "5",
        "svg": "ProductDetails",
        "cardName" : "ProductDetails",
        "description" : "Shows details from ck_product_details table with a specific SKU code",
        "query" : "SELECT * FROM ck_product_details WHERE sku_code = '';",
        "api" : "/v1/query/dataValidation_skucode?",
        "filters" : {
            "SKU code" : "skucode"
        },
        "filtersCheck" : {
            "check" : true,
            "value" : "="
        }
    }
]